import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementCampaignTotalDaily.graphql';
import { Query, QueryengagementCampaignReportArgs } from '../../__generated__/globalTypes';

export const useEngagementCampaignTotalDailyQuery = (
  options?: QueryHookOptions<Query, QueryengagementCampaignReportArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementCampaignTotalDailyLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementCampaignReportArgs>
): QueryResult<Query, QueryengagementCampaignReportArgs> & {
  getEngagementCampaignTotalDaily: LazyQueryExecFunction<Query, QueryengagementCampaignReportArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementCampaignTotalDaily, result] = useLazyQuery<Query, QueryengagementCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getEngagementCampaignTotalDaily, ...result };
};

export const useEngagementCampaignTotalDailyPromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementCampaignTotalDaily = useCallback(
    (options?: Omit<QueryOptions<QueryengagementCampaignReportArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementCampaignReportArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementCampaignTotalDaily };
};
// Suspense Query Hooks
export const useEngagementCampaignTotalDailySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementCampaignReportArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementCampaignReportArgs>(QUERY, {
    ...options
  });

  return result;
};
